import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import CmsPage from 'models/CmsPage';
import FaqCategory from 'models/FaqCategory';
import FaqPost from 'models/FaqPost';

import { LIST_MARKUP } from 'consts/redux';

import { single as singleCmsPage } from 'requests/cmsPages';
import { list as listFaqCategories } from 'requests/faqCategories';
import { list as listFaqPosts } from 'requests/faqPosts';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let faqCategories: ListCollection<FaqCategory> = LIST_MARKUP;
    let faqPosts: ListCollection<FaqPost> = LIST_MARKUP;
    let categorySlug: string = appContext?.query?.slug?.toString();
    const search: string = appContext?.query?.search?.toString();
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            listFaqCategories({
                page: 1,
                perPage: 999,
            }),
            singleCmsPage({ slug: 'faq' }),
        ]).then(responses => {
            faqCategories = responses[0];
            cmsPage = responses[1];
        });
    } catch (error) {
        console.error(error);
    }

    try {
        if(!categorySlug && !search) {
            const firstFaqCategory: FaqCategory = faqCategories?.elements?.length > 0
                ? faqCategories?.elements[0]
                : null;
            categorySlug = firstFaqCategory?.slug;
        }

        if(categorySlug || search) {
            await Promise.all([
                listFaqPosts({
                    page: 1,
                    perPage: 999,
                    categorySlug,
                    search,
                }),
            ]).then(responses => {
                faqPosts = responses[0];
            });
        }
    } catch (error) {
        console.error(error);
    }

    return {
        faqCategories,
        faqPosts,
        cmsPage,
    };
};

export default Component;

